/**
 * Form Modal
 * Handles modal open/close functionality with slide-in animation
 */

class FormModal {
  constructor(element) {
    this.modal = element;
    this.closeButtons = element.querySelectorAll('[data-modal-close]');
    this.init();
  }

  init() {
    this.closeButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.close();
      });
    });

    // Close on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal.classList.contains('is-active')) {
        e.preventDefault();
        this.close();
      }
    });
  }

  open(e) {
    if (e) {
      e.preventDefault();
    }
    this.modal.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  close(e) {
    if (e) {
      e.preventDefault();
    }
    this.modal.classList.remove('is-active');
    document.body.style.overflow = '';
  }
}

// Initialize all modals
document.addEventListener('DOMContentLoaded', () => {
  const modals = document.querySelectorAll('[data-modal]');
  const modalInstances = new Map();

  modals.forEach(modalElement => {
    const modal = new FormModal(modalElement);
    modalInstances.set(modalElement.id, modal);
  });

  // Global function to open modal by ID
  window.openModal = function(modalId) {
    const modal = modalInstances.get(modalId);
    if (modal) {
      modal.open();
    }
  };

  // Global function to close modal by ID
  window.closeModal = function(modalId) {
    const modal = modalInstances.get(modalId);
    if (modal) {
      modal.close();
    }
  };
});
